import { createStyles, makeStyles } from "@material-ui/core";

const lightThemeStyle = makeStyles(theme =>
  createStyles({
    "@global": {
      body: {
        background: "#F0F2F6",
        color: "#202f43",
      },
      loginFlow: {
        "& $formAction": {
          "& button": {
            backgroundColor: "red",
          },
        },
      },
      ".MuiDrawer-docked": {
        "& .MuiPaper-root": {
          background: "#fff",
          border: "none",
          boxShadow: "0px 3px 6px #00000029",
        },
        "& .Mui-selected": {
          borderColor: theme.palette.secondary.main,
        },
        "& .MuiListItemIcon-root": {
          "& img": {
            filter:
              "invert(50%) sepia(50%) saturate(371%) hue-rotate(187deg) brightness(90%) contrast(90%)",
          },
        },
        "& .MuiIconButton-root": {
          "& img": {
            filter:
              "invert(25%) sepia(50%) saturate(371%) hue-rotate(187deg) brightness(90%) contrast(90%)",
          },
        },
      },
    },
  })
);

export default lightThemeStyle;  
